import { createContext, useContext, useState, useEffect } from "react";

// Translations
const translations = {
  he: {
    // General
    loading: "טוען...",
    save: "שמור",
    cancel: "ביטול",
    delete: "מחק",
    edit: "ערוך",
    copy: "העתק",
    copied: "הועתק",
    search: "חיפוש",
    noData: "אין נתונים להצגה",

    // Navigation
    overview: "סקירה כללית",
    settings: "הגדרות",
    contracts: "חוזים",
    clients: "לקוחות",
    templates: "תבניות",
    webhooks: "Webhooks",
    usageBilling: "שימוש וחיוב",
    docs: "דוקומנטציה",
    logout: "התנתק",

    // Login
    companyAdminPortal: "פאנל ניהול לחברות",
    email: "אימייל",
    password: "סיסמה",
    signIn: "התחבר",
    signingIn: "מתחבר...",
    or: "או",
    continueWithGoogle: "המשך עם Google",
    dontHaveAccount: "אין לך חשבון?",
    signUpWithGoogle: "הירשם עם Google",
    createAccount: "צור חשבון",
    register: "הרשמה",
    registering: "נרשם...",
    companyNameLabel: "שם החברה",
    fullName: "שם מלא",
    phoneNumber: "מספר טלפון",
    alreadyHaveAccount: "כבר יש לך חשבון?",
    backToLogin: "חזרה להתחברות",
    loginWithSms: "התחבר עם SMS",
    sendCode: "שלח קוד",
    sendingCode: "שולח...",
    verificationCode: "קוד אימות",
    verify: "אמת",
    verifying: "מאמת...",
    codeSentTo: "קוד נשלח ל-",
    resendCode: "שלח שוב",
    documentation: "תיעוד",
    home: "דף הבית",
    loginFailed: "ההתחברות נכשלה. אנא בדוק את הפרטים שלך.",

    // Dashboard
    upgradeToEnterprise: "שדרג ל-Enterprise",
    contactSales: "צור קשר עם מכירות",
    fullAccess: "גישה מלאה לניהול חוזים, Webhooks ואינטגרציה ל-API.",
    planProfessionalExtra: "עד 100 חוזים בחודש, Webhooks ו-API.",
    unlimitedContracts: "חוזים ללא הגבלה, תמיכה עדיפה ואינטגרציות מותאמות.",
    planEnterpriseExtra: "חוזים ללא הגבלה, תמיכה ייעודית.",
    current: "נוכחי",
    manageSubscription: "נהל מנוי",
    upgradeSubscription: "שדרג מנוי",
    plans: "תוכניות",
    perMonth: "לחודש",
    contractsUsedThisMonth: "חוזים שנוצלו בחודש הנוכחי",
    editLimit: "ערוך מגבלה",
    yourAnalytics: "הסטטיסטיקות שלך",
    totalContracts: 'סה"כ חוזים',
    signed: "נחתמו",
    pending: "ממתינים",
    expired: "פג תוקף",
    contractsOverTime: "חוזים לאורך זמן",
    contractDistribution: "התפלגות חוזים",
    analyticsNote: "הסטטיסטיקות מתעדכנות בזמן אמת. עיין ב",
    forMoreInfo: "למידע נוסף.",
    totalClients: "סה\"כ לקוחות",
    newClientsInPeriod: "לקוחות חדשים בתקופה",
    activeTemplates: "תבניות פעילות",
    webhooksSuccessRate: "שיעור הצלחת Webhooks",
    contractsExpiringSoon: "חוזים שפג תוקפם בעוד 7 ימים",
    averageTimeToSign: "זמן חתימה ממוצע (ימים)",
    vsPreviousPeriod: "לעומת התקופה הקודמת",
    usageThisPeriod: "שימוש בתקופה",
    smsSent: "SMS נשלחו",
    apiCalls: "קריאות API",
    teamMembers: "חברי צוות",
    days: "ימים",
    noWebhooksYet: "אין עדיין Webhooks",

    // Settings
    profile: "פרופיל",
    apiKeys: "מפתחות API",
    security: "אבטחה",
    companyInformation: "פרטי החברה",
    personalDetailsSubtitle: "פרטי התקשורת והמנוי של החברה. ניתן לעדכן ולשמור.",
    companyName: "שם החברה",
    contactName: "שם ליצירת קשר",
    contactEmail: "אימייל ליצירת קשר",
    phone: "טלפון",
    subscriptionPlan: "תוכנית מנוי",
    saveProfile: "שמור פרטים",
    profileSaved: "הפרטים נשמרו בהצלחה",
    profileSaveFailed: "שמירת הפרטים נכשלה",

    // API Keys
    apiKeysWhatIs:
      "מפתחות API מאפשרים לאינטגרציות החיצוניות שלכם (אתר, מערכת) לשלוח ולקבל נתונים על חוזים בצורה מאובטחת.",
    apiKeysWhoFor: "מתאים למפתחים ומערכות שצריכים גישה מתוכנה ל-API.",

    // Webhooks
    webhookWhatIs:
      "Webhook מאפשר לקבל עדכונים בזמן אמת כשחוזה נוצר, נחתם או בוטל — ישירות לשרת שלכם.",
    webhookWhoFor:
      "מתאים לאינטגרציות שצריכות לסנכרן מערכות או להפעיל תהליכים אוטומטית.",
    webhookSendTitle: "מה אנחנו שולחים ומה מצופה בתגובה",
    webhookPayloadExample: "דוגמת payload שנשלח:",
    webhookExpectExample: "המערכת מצפה לסטטוס-200 - Response body לא נדרש.",

    // Security - Whitelist
    ipWhitelistWhatIs:
      "הגבלת גישת API לכתובות IP ספציפיות. רק בקשות מהכתובות ברשימה יאושרו.",
    ipWhitelistWhoFor: "מתאים לארגונים שדורשים הגבלת גישה לפי IP (משרד, שרת).",
    ipWhitelistExamples:
      "דוגמאות: כתובת בודדת (192.168.1.1) או טווח CIDR (10.0.0.0/24).",

    // API Keys
    apiKeysHowToUseTitle: "איך משתמשים במפתח",
    apiKeysHowToUseDesc: "שלח את המפתח הציבורי בכל בקשת API ב-header בשם X-API-Key:",
    apiKeysExampleHeaders: "Headers:",
    apiKeysExampleBody: "Request body (דוגמה):",
    productionApiKeys: "מפתחות API לייצור (Production)",
    sandboxApiKeys: "מפתחות API לסביבת בדיקות (Sendbox)",
    publicKey: "Public Key",
    rotateKeys: "חדש מפתחות",
    rotateSandboxKeys: "חדש מפתחות בדיקות",
    lastRotated: "חודש לאחרונה",
    never: "אף פעם",
    newSecretKey: "מפתח סודי חדש (שמור עכשיו!)",
    rotateKeysConfirm:
      "האם אתה בטוח שברצונך לחדש את מפתחות ה-API? המפתחות הישנים יפסיקו לעבוד מיד.",
    keysRotatedSuccess:
      "מפתחות ה-API חודשו בהצלחה. שמור את המפתח הסודי - הוא לא יוצג שוב!",
    keysRotateFailed: "נכשל בחידוש מפתחות ה-API",

    // Webhooks
    webhookConfiguration: "הגדרות Webhook",
    webhookEnabled: "Webhook פעיל",
    webhookUrl: "כתובת Webhook",
    sendTest: "שלח בדיקה",
    rotateSecret: "חדש Secret",
    webhookSaved: "הגדרות ה-Webhook נשמרו",
    webhookSaveFailed: "נכשל בשמירת הגדרות ה-Webhook",
    testWebhookSuccess: "Webhook לבדיקה נשלח בהצלחה!",
    testWebhookFailed: "נכשל בשליחת Webhook לבדיקה",
    newWebhookSecret: "Secret חדש ל-Webhook (שמור עכשיו!)",
    rotateSecretConfirm: "האם אתה בטוח שברצונך לחדש את ה-Webhook Secret?",
    secretRotatedSuccess: "ה-Webhook Secret חודש. שמור אותו - הוא לא יוצג שוב!",
    secretRotateFailed: "נכשל בחידוש ה-Webhook Secret",
    webhookStatsTotal: "סה\"כ שליחות",
    webhookStatsSuccessRate: "אחוז הצלחה",
    webhookStatsSuccess: "הצלחות",
    webhookStatsAvgTime: "זמן תגובה (ms)",
    webhookStatsFailed: "נכשל / מנסה שוב",
    viewDetails: "פרטים",
    retry: "שלח שוב",
    logDetails: "פרטי לוג",
    sendTestFromPage: "שלח בדיקת Webhook",
    exportAllFiltered: "ייצוא כל הלוגים (לפי סינון)",
    exportCurrentPage: "ייצוא עמוד נוכחי",
    responseTime: "זמן תגובה",
    errorMessage: "הודעת שגיאה",
    webhookClient: "לקוח",
    attemptsHistory: "היסטוריית ניסיונות",
    close: "סגור",
    contractLink: "קישור לחוזה",

    // Security
    securitySettings: "הגדרות אבטחה",
    ipWhitelistEnabled: "IP Whitelist פעיל",
    allowedIpAddresses: "כתובות IP מורשות (אחת בכל שורה)",
    rateLimitPerMinute: "מגבלת בקשות (לדקה)",
    saveSettings: "שמור הגדרות",
    securitySaved: "הגדרות האבטחה נשמרו",
    securitySaveFailed: "נכשל בשמירת הגדרות האבטחה",

    // Theme & Language
    lightMode: "מצב בהיר",
    darkMode: "מצב כהה",
    hebrew: "עברית",
    english: "English",
  },
  en: {
    // General
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    search: "Search",
    noData: "No data available",

    // Navigation
    overview: "Overview",
    settings: "Settings",
    contracts: "Contracts",
    clients: "Clients",
    templates: "Templates",
    webhooks: "Webhooks",
    usageBilling: "Usage & Billing",
    docs: "Documentation",
    logout: "Logout",

    // Login
    companyAdminPortal: "Company Admin Portal",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    or: "or",
    continueWithGoogle: "Continue with Google",
    dontHaveAccount: "Don't have an account?",
    signUpWithGoogle: "Sign up with Google",
    createAccount: "Create Account",
    register: "Register",
    registering: "Registering...",
    companyNameLabel: "Company Name",
    fullName: "Full Name",
    phoneNumber: "Phone Number",
    alreadyHaveAccount: "Already have an account?",
    backToLogin: "Back to Login",
    loginWithSms: "Login with SMS",
    sendCode: "Send Code",
    sendingCode: "Sending...",
    verificationCode: "Verification Code",
    verify: "Verify",
    verifying: "Verifying...",
    codeSentTo: "Code sent to ",
    resendCode: "Resend Code",
    documentation: "Documentation",
    home: "Home",
    loginFailed: "Login failed. Please check your credentials.",

    // Dashboard
    upgradeToEnterprise: "Upgrade to Enterprise",
    contactSales: "Contact Sales",
    fullAccess:
      "Full access to contract management, webhooks, and API integration.",
    planProfessionalExtra: "Up to 100 contracts/mo · Webhooks · API.",
    unlimitedContracts:
      "Unlimited contracts, priority support, and custom integrations.",
    planEnterpriseExtra: "Unlimited contracts · Dedicated support.",
    current: "Current",
    manageSubscription: "Manage Subscription",
    upgradeSubscription: "Upgrade Subscription",
    plans: "Plans",
    perMonth: "mo.",
    contractsUsedThisMonth: "Contracts Used this Month",
    editLimit: "Edit Limit",
    yourAnalytics: "Your Analytics",
    totalContracts: "Total Contracts",
    signed: "Signed",
    pending: "Pending",
    expired: "Expired",
    contractsOverTime: "Contracts Over Time",
    contractDistribution: "Contract Distribution",
    analyticsNote: "Analytics are updated in real-time. Check the",
    forMoreInfo: "for more info.",
    totalClients: "Total Clients",
    newClientsInPeriod: "New clients in period",
    activeTemplates: "Active Templates",
    webhooksSuccessRate: "Webhooks success rate",
    contractsExpiringSoon: "Contracts expiring in 7 days",
    averageTimeToSign: "Avg. time to sign (days)",
    vsPreviousPeriod: "vs previous period",
    usageThisPeriod: "Usage this period",
    smsSent: "SMS sent",
    apiCalls: "API calls",
    teamMembers: "Team members",
    days: "days",
    noWebhooksYet: "No webhooks yet",

    // Settings
    profile: "Profile",
    apiKeys: "API Keys",
    security: "Security",
    companyInformation: "Company Information",
    personalDetailsSubtitle:
      "Contact and subscription details. You can update and save.",
    companyName: "Company Name",
    contactName: "Contact Name",
    contactEmail: "Contact Email",
    phone: "Phone",
    subscriptionPlan: "Subscription Plan",
    saveProfile: "Save profile",
    profileSaved: "Profile saved successfully",
    profileSaveFailed: "Failed to save profile",

    // API Keys
    apiKeysWhatIs:
      "API keys let your external integrations (website, system) send and receive contract data securely.",
    apiKeysWhoFor:
      "For developers and systems that need programmatic access to the API.",

    // Webhooks
    webhookWhatIs:
      "Webhook sends real-time updates when a contract is created, signed, or cancelled — to your server.",
    webhookWhoFor:
      "For integrations that need to sync systems or trigger automated processes.",
    webhookSendTitle: "What we send and what we expect in response",
    webhookPayloadExample: "Example payload we send:",
    webhookExpectExample: "We expect status 200. - Response body is optional.",

    // Security - Whitelist
    ipWhitelistWhatIs:
      "Restrict API access to specific IP addresses. Only requests from listed IPs are allowed.",
    ipWhitelistWhoFor:
      "For organizations that require IP-based access control (office, server).",
    ipWhitelistExamples:
      "Examples: single IP (192.168.1.1) or CIDR range (10.0.0.0/24).",

    // API Keys
    apiKeysHowToUseTitle: "How to use the key",
    apiKeysHowToUseDesc: "Send the public key in every API request using the X-API-Key header:",
    apiKeysExampleHeaders: "Headers:",
    apiKeysExampleBody: "Request body (example):",
    productionApiKeys: "Production API Keys",
    sandboxApiKeys: "Sandbox API Keys",
    publicKey: "Public Key",
    rotateKeys: "Rotate Keys",
    rotateSandboxKeys: "Rotate Sandbox Keys",
    lastRotated: "Last rotated",
    never: "Never",
    newSecretKey: "New Secret Key (save it now!)",
    rotateKeysConfirm:
      "Are you sure you want to rotate the API keys? The old keys will stop working immediately.",
    keysRotatedSuccess:
      "API keys rotated successfully. Save the Secret Key - it won't be shown again!",
    keysRotateFailed: "Failed to rotate API keys",

    // Webhooks
    webhookConfiguration: "Webhook Configuration",
    webhookEnabled: "Webhook enabled",
    webhookUrl: "Webhook URL",
    sendTest: "Send Test",
    rotateSecret: "Rotate Secret",
    webhookSaved: "Webhook settings saved",
    webhookSaveFailed: "Failed to save webhook settings",
    testWebhookSuccess: "Test webhook sent successfully!",
    testWebhookFailed: "Failed to send test webhook",
    newWebhookSecret: "New Webhook Secret (save it now!)",
    rotateSecretConfirm: "Are you sure you want to rotate the webhook secret?",
    secretRotatedSuccess:
      "Webhook secret rotated. Save it - it won't be shown again!",
    secretRotateFailed: "Failed to rotate webhook secret",
    webhookStatsTotal: "Total deliveries",
    webhookStatsSuccessRate: "Success rate",
    webhookStatsSuccess: "Successes",
    webhookStatsAvgTime: "Response time (ms)",
    webhookStatsFailed: "Failed / Retrying",
    viewDetails: "Details",
    retry: "Retry",
    logDetails: "Log details",
    sendTestFromPage: "Send test webhook",
    exportAllFiltered: "Export all (filtered)",
    exportCurrentPage: "Export current page",
    responseTime: "Response time",
    errorMessage: "Error message",
    webhookClient: "Client",
    attemptsHistory: "Attempts history",
    close: "Close",
    contractLink: "Contract link",

    // Security
    securitySettings: "Security Settings",
    ipWhitelistEnabled: "IP Whitelist enabled",
    allowedIpAddresses: "Allowed IP Addresses (one per line)",
    rateLimitPerMinute: "Rate Limit (requests per minute)",
    saveSettings: "Save Settings",
    securitySaved: "Security settings saved",
    securitySaveFailed: "Failed to save security settings",

    // Theme & Language
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    hebrew: "עברית",
    english: "English",
  },
};

// Theme colors
export const themes = {
  dark: {
    bg: "#0a0a0a",
    bgSecondary: "#111111",
    bgTertiary: "#171717",
    border: "#262626",
    borderLight: "#333333",
    text: "#fafafa",
    textSecondary: "#a1a1a1",
    textMuted: "#737373",
    accent: "#3b82f6",
    accentHover: "#2563eb",
    success: "#22c55e",
    successBg: "#052e16",
    warning: "#eab308",
    warningBg: "#422006",
    error: "#ef4444",
    errorBg: "#450a0a",
  },
  light: {
    bg: "#ffffff",
    bgSecondary: "#f9fafb",
    bgTertiary: "#f3f4f6",
    border: "#e5e7eb",
    borderLight: "#d1d5db",
    text: "#111827",
    textSecondary: "#4b5563",
    textMuted: "#9ca3af",
    accent: "#2563eb",
    accentHover: "#1d4ed8",
    success: "#16a34a",
    successBg: "#dcfce7",
    warning: "#ca8a04",
    warningBg: "#fef9c3",
    error: "#dc2626",
    errorBg: "#fef2f2",
  },
};

const AppContext = createContext();

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useApp must be used within AppProvider");
  }
  return context;
};

export const AppProvider = ({ children }) => {
  // Get saved preferences or defaults
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem("app_language") || "he";
  });

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("app_theme") || "dark";
  });

  const SIDEBAR_LOGO_KEY = "company_sidebar_logo";
  const SIDEBAR_NAME_KEY = "company_sidebar_name";

  const [companyLogoUrl, setCompanyLogoUrl] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_LOGO_KEY) || null;
    } catch {
      return null;
    }
  });
  const [companyNameFromServer, setCompanyNameFromServer] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_NAME_KEY) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    try {
      if (companyLogoUrl != null) localStorage.setItem(SIDEBAR_LOGO_KEY, companyLogoUrl);
      else localStorage.removeItem(SIDEBAR_LOGO_KEY);
    } catch (_) {}
  }, [companyLogoUrl]);

  useEffect(() => {
    try {
      if (companyNameFromServer != null) localStorage.setItem(SIDEBAR_NAME_KEY, companyNameFromServer);
      else localStorage.removeItem(SIDEBAR_NAME_KEY);
    } catch (_) {}
  }, [companyNameFromServer]);

  // Save preferences
  useEffect(() => {
    localStorage.setItem("app_language", language);
    document.documentElement.dir = language === "he" ? "rtl" : "ltr";
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    localStorage.setItem("app_theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  // Toggle functions
  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "he" ? "en" : "he"));
  };

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const isRTL = language === "he";
  const isDark = theme === "dark";
  const colors = themes[theme];

  return (
    <AppContext.Provider
      value={{
        language,
        setLanguage,
        theme,
        setTheme,
        companyLogoUrl,
        setCompanyLogoUrl,
        companyNameFromServer,
        setCompanyNameFromServer,
        t,
        toggleLanguage,
        toggleTheme,
        isRTL,
        isDark,
        colors,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
